<template>
    <div class="field checkboxes checkboxes--inline field--full" :class="{ 'required': required }">
        <div class="heading">
            <legend><span class="legend-text">{{ heading }}</span></legend>
        </div>
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        heading: {
            type: String,
            default: 'Checklist'
        },
        required: {
            type: Boolean,
            default: false
        },
    },
}
</script>
